





















































































import TextbookIssuePagesTable from './components/TextbookIssue/TextbookIssuePagesTable.vue'
import MediaLibrary from './components/media/MediaLibrary.vue'
import {
  defineComponent,
  ref,
  onBeforeMount,
  inject,
  watch,
} from '@vue/composition-api'
import {
  addSelectedMediaItemsToPages,
  getTextbookIssuePages,
} from '@/shared/api'
import { alertSymbol } from '@/shared/state-management/symbols'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'
import { TextbookIssue, TextbookIssuePage } from '@/shared/types'
import { useStore as useUserStore } from '@/shared/state-management/userStore'
import { CREATE_MEDIA_ITEM_OCCURENCE } from '@/shared/user/permissions'

export default defineComponent({
  name: 'TextbookIssuePages',
  components: {
    TextbookIssuePagesTable,
    MediaLibrary,
  },
  setup(_, context) {
    const loading = ref(false)
    const draggedItemId = ref(null)
    const $alert = inject(alertSymbol) as Function
    const showMediaLibrary = ref(false)
    const textbookIssuePages = ref([] as TextbookIssuePage[])
    const { getters } = useTextbookStore()
    const { activeTextbook, activeTextbookIssue } = getters
    const { hasPermissionTo } = useUserStore().getters
    const itemsPerPaginationPage = ref(10)
    const paginationPage = ref(1)
    const mediaLibrary = ref(null)
    const selectedPages = ref([] as number[])
    const updateSelectedPages = () => {
      const lowerPageNumber =
        (paginationPage.value - 1) * itemsPerPaginationPage.value + 1
      const upperPageNumber =
        paginationPage.value * itemsPerPaginationPage.value
      const newPages = selectedPages.value.filter(
        (page: number) => page >= lowerPageNumber && page <= upperPageNumber
      )

      if (newPages.length !== selectedPages.value.length) {
        selectedPages.value = newPages
      }
    }

    const refreshPages = async (textbookIssueId = '') => {
      textbookIssueId = textbookIssueId || activeTextbookIssue.value?.id
      if (
        !(
          textbookIssueId &&
          textbookIssueId === context.root.$route.params.textbookIssueId
        )
      ) {
        return
      }
      loading.value = true
      if (!activeTextbookIssue.value) {
        return
      }
      try {
        textbookIssuePages.value = await getTextbookIssuePages(
          textbookIssueId,
          itemsPerPaginationPage.value,
          paginationPage.value
        )

        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    const handlePageClicked = (page: number) => {
      const index = selectedPages.value.indexOf(page)
      if (index === -1) {
        selectedPages.value = [
          ...selectedPages.value,
          page,
        ].sort((a: number, b: number) => (a < b ? -1 : 1))
        return
      }
      selectedPages.value.splice(index, 1)
    }

    onBeforeMount(async () => {
      refreshPages()
    })

    watch(
      () => activeTextbookIssue.value,
      (newVal: TextbookIssue) => (newVal ? refreshPages(newVal.id) : null)
    )

    const onDragStartMediaItem = (mediaItemId: string) => {
      draggedItemId.value = mediaItemId
    }

    const onMediaItemDropped = async (droppedData: {
      event: DragEvent
      data: string
      page: number
    }) => {
      const { data, page, event } = droppedData
      const ids = data.split(',') as Array<string>
      if (loading.value) {
        return
      }
      if (data === draggedItemId.value) {
        event.preventDefault()
        loading.value = true
        try {
          const reponseArray = await addSelectedMediaItemsToPages(
            activeTextbookIssue.value.id,
            ids,
            [page]
          )

          if (reponseArray.length === 0) {
            $alert({
              type: 'warning',
              text: context.root.$t('mediaItem.addToPagesEmpty'),
            })
            refreshPages()
            return
          }

          $alert({
            type: 'success',
            text: context.root.$t('mediaItem.addToPagesSuccess', {
              created: reponseArray.length,
            }),
          })
          mediaLibrary.value.refreshMediaItems()
        } catch (e) {
          loading.value = false
          throw e
        }
      }
    }

    return {
      loading,
      activeTextbook,
      onDragStartMediaItem,
      draggedItemId,
      onMediaItemDropped,
      showMediaLibrary,
      itemsPerPaginationPage,
      paginationPage,
      activeTextbookIssue,
      textbookIssuePages,
      refreshPages,
      hasPermissionTo,
      CREATE_MEDIA_ITEM_OCCURENCE,
      mediaLibrary,
      selectedPages,
      handlePageClicked,
      updateSelectedPages,
    }
  },
})
